import { Grid } from "@huub-web/ui";
import { IndexItem } from "./components/IndexItem";
import { gridStyle } from "./AnalysisIndex.css";

export type AnalysisIndexProps = {
  items: {
    index: number;
    title: string;
    subtitle?: string;
    disabled?: boolean;
    loading?: boolean;
    noData?: boolean;
  }[];
  onItemClick: (index: number) => void;
};

export const AnalysisIndex = ({ items, onItemClick }: AnalysisIndexProps) => (
  <Grid variant="none" as="ul" className={gridStyle}>
    {items.map((item) => (
      <IndexItem
        key={item.index}
        index={item.index}
        title={item.title}
        subtitle={item.subtitle}
        onClick={() => onItemClick(item.index)}
        disabled={item.disabled}
        loading={item.loading}
        noData={item.noData}
        positiveCount={items.length % 2 === 0}
      />
    ))}
  </Grid>
);
